<template>
    <b-card>
        <b-card-title>
            {{ cmdName }}
        </b-card-title>
        <b-card-body>
            <p v-if="description">
                {{ description.Description }}
            </p>
            <b-row v-for="(a, idx) in args" :key="idx" v-if="idx>0">
                    <b-col cols="3">{{ idx }}:<b v-if="description">{{ description.Args[idx].Name }}</b></b-col>
                    <b-col><b-form-input :type="GetTypeFromDescription(description,idx)" v-model="work[idx]"  :readonly="!editMode"></b-form-input></b-col>
                    <b-col cold="3" v-if="description">{{ description.Args[idx].Description }} ({{ description.Args[idx].Type }})</b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>
<script>
import { Api } from "../../lib/api";
const api = new Api();

const typeConv = [
                {argType:'int',type:'number'},
                {argType:'pwd',type:'password'},
                {argType:'password',type:'password'}, 
                ];


export default {
    name: 'inboxargs',
    props: {
        args: Array,
        editMode: Boolean,
        clientId: String,
    },
    data() {
        return {
            work: null,
            description: null,
            cmdName: null,
        }
    },
    created() {
        this.setWork();
    },
    methods:
    {
        setWork() {
            this.work = JSON.parse(JSON.stringify(this.args));
            this.cmdName = this.work[0];
            api.get(`api/inbox/GetDescription?clientId=${this.clientId}&commandName=${this.cmdName}`).then(res => {
                this.description = res.data;
            });
        },
        GetTypeFromDescription(argDescr,idx) {

            let res = 'text';
            if(argDescr) {
                const d = argDescr.Args[idx];
                const sf = d.Type.toLowerCase();
                const t = typeConv.find(x => x.Type === sf);
                if(t) res = t.type;                
            }
                
            return res;
        }
    }
}

</script>